




























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Element, ElementType } from '@/models'
import { ActionTypes } from '@/store/action-types'
import { DEFAULT_ICON_ELEMENT_TYPE } from '@/utils/constants'

@Component({
  components: {
    RelationToInfo: () => import('@/components/productDetail/RelationToInfo.vue'),
    RelationToListInfo: () => import('@/components/productDetail/RelationToListInfo.vue'),
    TypeIcon: () => import('@/components/TypeIcon.vue')
  }
})
export default class ProductServicesList extends Vue {
  @Prop({ required: true, type: Object }) element: Element
  @Prop({ required: false, type: Number }) index: number

  get elementTypes(): ElementType[] {
    return this.$store.getters.elementTypes
  }

  created() {
    this.loadElementTypes()
  }

  async loadElementTypes() {
    await this.$store.dispatch(ActionTypes.LOAD_ELEMENT_TYPES)
  }

  private getElementTypeIcon(type: string) {
    const elementType = this.elementTypes.find((item: ElementType) => item.codeId === type)
    if (!elementType || !elementType.icon) {
      return DEFAULT_ICON_ELEMENT_TYPE
    }
    return elementType.icon
  }
}
